















import {
	computed,
	defineComponent,
	PropType,
	ref,
	watch,
} from '@vue/composition-api';
import { getFirstFocusableElement } from '@front-app/util/a11y';
import { StepperAnimationType } from './useStepper';

export default defineComponent({
	props: {
		currentStep: {
			type: Number,
			required: true,
		},
		animationType: {
			type: String as PropType<StepperAnimationType>,
			required: true,
		},
	},
	setup(props) {
		const previousStep = ref(0);
		watch(() => props.currentStep, (curr) => {
			previousStep.value = curr;
		});

		const focusFirstElement = async (el: HTMLElement) => {
			if (!el) {
				// eslint-disable-next-line no-console
				console.warn('No container found for vf-stepper');
				return;
			}
			getFirstFocusableElement(el)?.focus();
		};

		const isSlideToRight = computed(() => props.animationType === StepperAnimationType.TO_RIGHT);

		return {
			focusFirstElement,
			previousStep,
			isSlideToRight,
		};
	},
});
